import { MutableRefObject } from "react";
import { Box, Container } from "@mui/system";
import MoneyReceiptDemoForTrainee from "./MoneyReceiptDemoForTrainee";

const PrintSingleMoneyReceiptForTrainee = ({
  componentRef,
  singleMoneyReceipt,
}: {
  componentRef: MutableRefObject<any>;
  singleMoneyReceipt: any;
}) => {
  return (
    <Box ref={componentRef} sx={{ pt: 2 }}>
      <Container
        sx={{
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        maxWidth="md"
      >
        <MoneyReceiptDemoForTrainee singleMoneyReceipt={singleMoneyReceipt} />
        <hr
          style={{
            width: "100%",
            borderTop: "2px dashed black",
            marginTop: "30px",
          }}
        />
        <MoneyReceiptDemoForTrainee singleMoneyReceipt={singleMoneyReceipt} />
      </Container>
    </Box>
  );
};

export default PrintSingleMoneyReceiptForTrainee;
